import { FeesRepo } from '@services/fees.repo';
import { FeeType, FeeTier } from '@models/fees/fee.models';
import * as angular from 'angular';

class FeeTypeManagementController implements ng.IOnInit {

  public feeTypes: Array<FeeType> = [];
  public isLoading: boolean = false;

  /** @ngInject */
  constructor(private feesRepo: FeesRepo, private $mdDialog: angular.material.IDialogService, private $rootScope: angular.IRootScopeService, private notifyjs) {

  }

  $onInit() {
    this.getFeeTypes()
  }

  formatBooleanValue = (value: boolean) => {
    return value ? 'Yes' : 'No'
  }

  convertDecToPerc = (x: number) => {
    return +(x * 100).toFixed(4);
  }

  addNewFeeTypeDialog = () => {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.feeType = {};
    this.$mdDialog.show({
      template: '<md-dialog flex="30" style="max-height:100% !important;"><add-fee-type-dialog fee-type=feeType> </add-fee-type-dialog></md-dialog>'
    }).then(res => {
      if (res == true) {
        this.getFeeTypes()
      }
    })
  }

  getFeeTypes = () => {
    this.isLoading = true;
    this.feesRepo.getFeeTypes(null)
      .then(res => {
        this.feeTypes = res.data as Array<any>;
        this.feeTypes.forEach(ft => {
          ft.isEdited = false;
        })
      })
      .catch()
      .finally(() => {
        this.isLoading = false;
      });
  }


  editFeeType = (feeType: FeeType) => {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.feeType = angular.copy(feeType);

    if (!feeType.isTiered) {
      tempScope.feeType.feeTiers = [];
    } else {
      let feeTiers: Array<FeeTier> = feeType.feeTiers.map(ft => {
        return {
          low: ft.low,
          high: ft.high == null ? 0 : ft.high,
          value: +(ft.value * 100).toFixed(4),
          id: ft.id ? ft.id : -1 // for non tiered fee
        }
      })
      tempScope.feeType.feeTiers = feeTiers;
    }

    this.$mdDialog.show({
      template: '<md-dialog flex="30" style="max-height:100% !important;"><add-fee-type-dialog fee-type="feeType"> </add-fee-type-dialog></md-dialog>',
      scope: tempScope
    }).then((res) => {
        if (res == true) {
          this.getFeeTypes()
        }
      }).catch((err )=> {
          console.log(err)
      })

  }
}





export const feeTypeManagement: angular.IComponentOptions = {
  template: require('./fees.feetype.management.html'),
  controller: FeeTypeManagementController
};



// WEBPACK FOOTER //
// ./src/app/fees/feeTypeManagement/fees.feetype.management.ts